/**
 * @generated SignedSource<<3ce9948aed2f20688b462e1bcf5fb317>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type entityLinkHeaderFeaturesArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null | undefined> | null | undefined;
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
      readonly published: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "entityLinkHeaderFeaturesArticle";
};
export type entityLinkHeaderFeaturesArticle$key = {
  readonly " $data"?: entityLinkHeaderFeaturesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"entityLinkHeaderFeaturesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "entityLinkHeaderFeaturesArticle"
};

(node as any).hash = "4a653f9a44656677885e247b1f4d4380";

export default node;
